export type ShadowLayer = {
  offsetX: string;
  offsetY: string;
  blur: string;
  color: string;
};

export const firstShadowSLayer: ShadowLayer = {
  offsetX: '0px',
  offsetY: '1px',
  blur: '3px',
  color: 'rgba(17, 23, 34, 0.12)',
};

export const secondShadowSLayer: ShadowLayer = {
  offsetX: '0px',
  offsetY: '1px',
  blur: '2px',
  color: 'rgba(17, 23, 34, 0.06)',
};

const getShadow = (shadow: ShadowLayer) =>
  `${shadow.offsetX} ${shadow.offsetY} ${shadow.blur} ${shadow.color}`;

export type Shadow = 'shadowXS' | 'shadowS' | 'shadowM' | 'shadowL';

export const shadowTokenDefinitions: Record<Shadow, string> = {
  shadowXS: '0px 1px 2px rgba(58, 5, 58, 0.1)',
  shadowS: `${getShadow(firstShadowSLayer)}, ${getShadow(secondShadowSLayer)}`,
  shadowM: '0px 0px 2px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.14)',
  shadowL:
    '0 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -4px rgba(0, 0, 0, 0.10)',
};

export const shadowDarkModeTokens: Record<Shadow, string> = {
  shadowXS: '0 0 0 1px var(--border-subtle), 0px 1px 2px rgba(0, 0, 0, 0.5)',
  shadowS: '0 0 0 1px var(--border-subtle), 0px 2px 6px rgba(0, 0, 0, 0.55)',
  shadowM: '0 0 0 1px var(--border-subtle), 0px 4px 16px rgba(0, 0, 0, 0.6)',
  shadowL: '0 0 0 1px var(--border-subtle), 0px 12px 28px rgba(0, 0, 0, 0.65)',
};

export const shadowXS = 'var(--shadow-xs)';

export const shadowS = 'var(--shadow-s)';

export const shadowM = 'var(--shadow-m)';

export const shadowL = 'var(--shadow-l)';

export const shadows: Record<Shadow, string> = {
  shadowXS,
  shadowS,
  shadowM,
  shadowL,
};
